<template>
  <m-header :class="{isLandingPage: $route.matched.some(record => record.meta.landingPage)}">
    <template #left>
      <p v-if="!hideBanner && mode !== 'production'" class="mode-banner" v-on:click="hideBanner = true">{{ baseUrl }}</p>
      <router-link :to="headerLink">
        <h1
            :class="{'not-authenticated': !authenticated, 'authenticated': authenticated}"
            :style="scaledStyle"
            class="logo-title"
            @click="logoClick"
        >
          <svg class="svg-logo"
               fill="none"
               viewBox="0 0 75 79"
               xmlns="http://www.w3.org/2000/svg"
          >
            <path
                d="M6.78089 78.9864C5.74324 78.9864 4.68147 78.7444 3.66795 78.2603C1.42375 77.1713 0.0482625 75.0416 0 72.5973V10.9631C0 4.91284 4.89865 0 10.9315 0H64.0685C70.1014 0 75 4.91284 75 10.9631V72.5004C74.9517 75.0658 73.6004 77.1713 71.332 78.2845C68.943 79.4462 66.168 79.18 64.0685 77.5827L39.1168 58.2943C38.5135 57.7861 37.9102 57.2779 37.3069 56.7697L36.945 57.4231C36.6554 57.8829 36.4141 58.246 36.1969 58.5122C35.1593 59.9642 33.5907 61.3437 31.9015 62.3359C30.1641 63.3282 28.2336 63.9574 26.3272 64.1026L25.6998 64.151C23.4315 64.151 21.5975 63.5702 20.1013 62.4328C18.4122 61.0775 17.4228 59.0688 17.2539 56.7455L17.2056 56.2373C17.2056 53.8897 18.0019 51.7358 19.4498 50.1628C20.9218 48.5413 22.8523 47.5248 25.0241 47.2344C29.6332 46.6294 33.5907 48.8317 35.9073 50.5742C36.1486 49.9691 36.3658 49.2915 36.583 48.5897C37.5483 45.4677 38.4653 41.9585 39.2857 38.159C39.5029 37.3361 39.8407 35.9566 40.1786 34.5772C40.7095 32.1087 41.1921 29.9063 41.6747 27.9461C41.6023 27.9703 41.5299 27.9703 41.4334 27.9945L40.9508 28.0913C33.4218 29.8579 24.8793 31.8666 24.5415 37.3361C24.5174 37.6265 24.5174 37.7233 24.5415 37.8443C24.6139 38.9092 23.8176 39.8288 22.7558 39.9256C21.7181 40.0224 20.777 39.1996 20.6805 38.1348C20.6564 37.8201 20.6322 37.3845 20.7046 36.9005C21.2114 28.7931 31.2259 26.4214 40.0579 24.3401L40.5405 24.2191C41.2645 24.0497 42.0125 23.8802 42.7365 23.7108C42.9537 22.9606 43.1708 22.2588 43.3639 21.5811H43.388C43.5087 21.1939 43.6535 20.7825 43.7983 20.4195L44.0396 19.7902C44.7152 18.072 45.5598 16.5957 46.5251 15.4582C47.7799 13.8852 49.3243 12.8929 51.0859 12.5299L51.3272 12.5057L52.8234 12.3847L53.0647 12.4331C53.8127 12.5541 54.6332 12.6993 55.3571 13.1349C56.3948 13.6431 57.167 14.5386 57.5772 15.7244L57.7461 17.1281V17.2491C57.4566 22.6702 52.3407 24.9693 47.9006 26.3488L45.8736 26.8812C45.2461 29.2771 44.5946 32.0845 43.8948 35.4242C43.5328 36.9247 43.195 38.3768 43.0019 39.1028C42.1815 42.9024 41.2403 46.5084 40.251 49.7755C39.8407 51.034 39.4305 52.1714 38.9961 53.2121C39.8407 53.9139 40.7095 54.6158 41.5541 55.3418L43.4363 56.8423L66.4093 74.4849C67.4952 75.332 68.7983 75.1868 69.6429 74.7754C70.0772 74.5575 71.1149 73.9283 71.139 72.5489V10.9631C71.139 7.06675 67.9778 3.87219 64.0685 3.87219H10.9315C7.0222 3.87219 3.861 7.04255 3.861 10.9631V72.5004C3.88514 73.9283 4.89865 74.5818 5.35714 74.7996C6.20174 75.211 7.4807 75.3562 8.59073 74.5092L18.8948 67.6602C19.7876 67.0552 20.9701 67.3214 21.5734 68.2168C22.1525 69.1123 21.9112 70.2981 21.0183 70.9032L10.8108 77.6795C9.65251 78.5265 8.22876 78.9864 6.78089 78.9864ZM26.5685 50.9614C26.2066 50.9614 25.8687 50.9856 25.5068 51.034C24.2519 51.2034 23.166 51.76 22.2973 52.7039C21.5251 53.5509 21.0666 54.8094 21.0666 56.0436L21.0907 56.4067C21.1873 57.6651 21.6699 58.6816 22.4662 59.335C23.2143 59.9158 24.2761 60.2304 25.5309 60.2304L26.0135 60.182C27.3407 60.0852 28.7403 59.6496 29.9469 58.9236C31.1776 58.2217 32.3118 57.2053 33.1564 56.0678C33.3736 55.8016 33.4701 55.6322 33.5907 55.4386L34.194 54.3254C34.2181 54.277 34.2423 54.2286 34.2664 54.1802C32.8427 52.9701 29.9228 50.9614 26.5685 50.9614ZM52.7027 16.2085L51.7374 16.2811C51.0618 16.4263 50.2654 16.9587 49.5415 17.8784C48.8176 18.7254 48.2143 19.8145 47.7075 21.0729L47.4662 21.7263C47.3697 21.9684 47.2732 22.2346 47.2008 22.4766C51.7375 21.0003 53.7403 19.403 53.9093 17.1039L53.7451 16.7972C53.6969 16.7004 53.6479 16.652 53.5473 16.4747C53.306 16.3053 52.944 16.2569 52.7027 16.2085Z"
                fill="#07132B"/>
          </svg>
          <span class="liffery">Liffery</span>
        </h1>
      </router-link>
    </template>

    <template #right>
      <m-header-item-right v-if="isNotBusinessLandingPage" :class="{'is-hidden-mobile': !authenticated}">
        <m-item-entry-trigger/>
      </m-header-item-right>

      <m-header-item-right v-if="isNotBusinessLandingPage"
                           :class="{ 'not-authenticated is-hidden-mobile': !authenticated }">
        <m-shopping-list-header/>
      </m-header-item-right>

      <m-header-item-right v-if="isNotBusinessLandingPage && authenticated"
                           :class="{ 'not-authenticated is-hidden-mobile': !authenticated }">
        <m-notification-header/>
      </m-header-item-right>

      <m-header-item-right v-if="isNotBusinessLandingPage && authenticated">
        <m-user-profile-header/>
      </m-header-item-right>

      <m-header-item-right v-if="isNotBusinessLandingPage && !authenticated">
        <m-header-login-trigger/>
      </m-header-item-right>

      <m-header-item-right v-if="!isNotBusinessLandingPage" class="is-hidden-mobile">
        <m-book-demo/>
      </m-header-item-right>
      <m-header-item-right v-if="!isNotBusinessLandingPage">
        <b-button class="is-outlined is-rounded accounts-link" type="is-primary"
                  @click="accountsClick">
          <a :href="accountHref">Business Login/ Signup</a>
        </b-button>
      </m-header-item-right>
    </template>
  </m-header>
</template>

<style lang="scss" scoped>
.mode-banner {
  position: absolute;
  bottom: 50%;
  left: 50%;
  font-size: small;
}

::v-deep {
  &.isLandingPage {
    background-color: var(--light-pastel-green);
  }
}

.accounts-link a {
  color: var(--primary-color) !important;
}

.logo-title {
  display: flex;
  align-items: center;
  justify-content: flex-start;
  height: 75px;

  @media (hover: hover) {
    &:hover {
      .svg-logo,
      .liffery {
        color: var(--primary-color);

        path {
          fill: var(--primary-color);
        }
      }
    }
  }

  .svg-logo,
  .liffery {
    transition: .2s;

    path {
      transition: .2s;
    }
  }

  &.authenticated {
    @media screen and (max-width: 460px) {
      height: 4rem;
    }

    @media screen and (max-width: 450px) {
      font-size: 1.8rem !important;
    }

    svg {
      @media screen and (max-width: 320px) {
        display: none;
      }
    }

    ::v-deep .svg-logo {
      width: 40px;
      height: 42px;

      @media screen and (max-width: 450px) {
        width: 30px;
        height: 31.5px;
        margin-right: 7px;
      }

      @media screen and (max-width: 356px) {
        max-height: 25px;
        margin-right: 4px;
      }
    }
  }

  &.not-authenticated {
    @media screen and (max-width: 380px) {
      ::v-deep svg {
        display: none;
      }
    }
  }

  .liffery {
    padding-top: 3px;
  }

  ::v-deep .svg-logo {
    width: 40px;
    height: 42px;
    margin-top: 1px;
    margin-right: 12px;
  }
}
</style>

<script lang="ts">
import { Component, Vue } from 'vue-property-decorator';
import MItemEntryTrigger from '@/components/molecules/itemEntry/MItemEntryTrigger.vue';
import MShoppingListHeader from '@/components/molecules/shoppingList/MShoppingListHeader.vue';
import MNotificationHeader from '@/components/molecules/notification/MNotificationHeader.vue';
import MUserProfileHeader from '@/components/molecules/MUserProfileHeader.vue';
import MHeaderLoginTrigger from '@/components/molecules/MHeaderLoginTrigger.vue';

import { AuthenticationStore } from '@/store';
import EventBus, { EventBusEvents } from '@/EventBus';
import { RouteNames } from '@/router/RouteNames';
import MHeader from '@/storybook-components/src/stories/molecules/MHeader.vue';
import MHeaderItemRight from '@/storybook-components/src/stories/molecules/MHeaderItemRight.vue';
import fontPercentageToScale from '@/utils/fontPercentageToScale';
import MBookDemo from '@/components/molecules/for-business/MBookDemo.vue';
import config from '@/config';

@Component({
  components: {
    MBookDemo,
    MHeaderItemRight,
    MHeader,
    MNotificationHeader,
    MShoppingListHeader,
    MHeaderLoginTrigger,
    MItemEntryTrigger,
    MUserProfileHeader
  },
})
export default class MAppHeader extends Vue {
  scaledStyle: Partial<CSSStyleDeclaration> = {};
  font = false;
  accountHref = config.accountsHref;

  hideBanner = false;
  baseUrl = config.api.baseUrl;
  mode = config.mode;

  get authenticated () {
    return AuthenticationStore.authenticated;
  }

  get headerLink () {
    return {
      name: this.authenticated ? RouteNames.ROUTE_DASHBOARD : RouteNames.ROUTE_INFO_WHAT_IS
    };
  }

  get isNotBusinessLandingPage () {
    return this.$route.name !== RouteNames.ROUTE_INFO_BUSINESS;
  }

  created () {
    this.scaledStyle = fontPercentageToScale();
  }

  logoClick () {
    EventBus.$emit(EventBusEvents.LOGO_CLICK, {
      from: this.$route.name
    });
  }

  accountsClick () {
    window.location.href = this.accountHref;
  }
}
</script>
